(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dlh-available-alternatives"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dlh-available-alternatives')) {
    class DlhAvailableAlternatives extends HTMLElement {
      connectedCallback() {
        this.picker = this.closest('section')?.querySelector('variant-radios, variant-selects');
        this.onPickerChange = () => this.update();
        this.picker?.addEventListener('change', this.onPickerChange);
      }

      disconnectedCallback() {
        this.picker?.removeEventListener('change', this.onPickerChange);
      }

      update() {
        const variant = this.picker?.currentVariant;
        if (!variant) return;
        this.hidden = Boolean(variant.available);
        if (!variant.available) {
          this.querySelector('[data-selected-variant]').textContent =
            this.dataset.soldOutTemplate.replace(
              '[variant]',
              this.dataset.colorOption === 'true' ? variant.option1 : variant.title
            );
        }
      }
    }
    customElements.define('dlh-available-alternatives', DlhAvailableAlternatives);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dlh-phone-links"] && !Shopify.designMode) return;
  try {
    const dlhRepairPhoneLinks = () => {
    document.querySelectorAll('a[href*="google.com/search"]').forEach((link) => {
      if (link.textContent.replace(/[^0-9]/g, '') === '12817909768') {
        link.href = 'tel:+12817909768';
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dlhRepairPhoneLinks, { once: true });
  } else {
    dlhRepairPhoneLinks();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dlh-shipping-estimator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-rate-estimator')) {
    class ShippingRateEstimator extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.form = this.querySelector('form');
        this.status = this.querySelector('.dlh-shipping-estimator__status');
        this.results = this.querySelector('.dlh-shipping-estimator__results');
        this.summaryText = this.querySelector('.dlh-shipping-estimator__summary-text');
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.countrySelect = this.form.elements.country;
        this.provinceSelect = this.form.elements.province;
        this.provinceField = this.querySelector('.dlh-shipping-estimator__province');
        this.provinceData = this.querySelector('.dlh-shipping-estimator__province-data');
        this.fieldErrors = Array.from(this.querySelectorAll('[data-field-error]'));
        this.state = window.dlhShippingEstimateState || {
          destination: null,
          hasEstimate: false,
          autoEstimate: false,
          open: false,
          resultText: '',
        };
        window.dlhShippingEstimateState = this.state;
        this.state.autoEstimate = Boolean(this.state.autoEstimate || this.state.hasEstimate);
        this.requestId = 0;
        this.automaticTimer = null;
        this.onSubmit = this.estimate.bind(this);
        this.onInput = (event) => {
          if (event.target === this.countrySelect) this.populateProvinces('');
          this.requestId += 1;
          this.submitButton.disabled = false;
          this.results.textContent = '';
          this.status.textContent = '';
          this.clearErrors();
          this.summaryText.textContent = this.dataset.title;
          this.state.hasEstimate = false;
          this.state.autoEstimate = false;
          this.state.resultText = '';
          this.saveDestination();
        };
        this.onToggle = () => { this.state.open = this.details.open; };
        this.form.addEventListener('submit', this.onSubmit);
        this.form.addEventListener('input', this.onInput);
        this.form.addEventListener('change', this.onInput);
        this.details.addEventListener('toggle', this.onToggle);
        this.restoreState();
        this.onCartChange = () => {
          this.requestId += 1;
          this.submitButton.disabled = false;
          if (this.state.autoEstimate && this.validDestination()) {
            this.state.hasEstimate = false;
            this.state.resultText = '';
            this.status.textContent = this.dataset.updating;
            this.results.textContent = '';
            this.summaryText.textContent = this.dataset.updating;
            this.queueAutomaticEstimate();
          }
        };
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartChange);
        }
        if (this.state.autoEstimate && this.validDestination()) this.queueAutomaticEstimate();
      }

      disconnectedCallback() {
        this.requestId += 1;
        clearTimeout(this.automaticTimer);
        this.form.removeEventListener('submit', this.onSubmit);
        this.form.removeEventListener('input', this.onInput);
        this.form.removeEventListener('change', this.onInput);
        this.details.removeEventListener('toggle', this.onToggle);
        if (this.unsubscribe) this.unsubscribe();
      }

      restoreState() {
        const destination = this.state.destination;
        if (destination) {
          this.countrySelect.value = destination.country;
          this.form.elements.zip.value = destination.zip;
        }
        this.populateProvinces(destination ? destination.province : '');
        this.details.open = Boolean(this.state.open);
        if (this.state.hasEstimate && this.state.resultText) {
          this.results.textContent = this.state.resultText;
          this.summaryText.textContent = this.state.resultText;
        }
      }

      destination() {
        return {
          country: this.form.elements.country.value.trim(),
          province: this.form.elements.province.value.trim(),
          zip: this.form.elements.zip.value.trim(),
        };
      }

      saveDestination() {
        this.state.destination = this.destination();
        this.state.open = this.details.open;
      }

      populateProvinces(selectedProvince) {
        const countryName = this.countrySelect.selectedOptions[0]?.dataset.countryName || '';
        const source = Array.from(this.provinceData.options).find((option) => option.value === countryName || option.textContent.trim() === countryName);
        let provinces = [];
        try {
          provinces = JSON.parse(source?.dataset.provinces || '[]');
        } catch {
          provinces = [];
        }
        this.provinceSelect.replaceChildren();
        if (!provinces.length) {
          this.provinceSelect.disabled = true;
          this.provinceSelect.required = false;
          this.provinceField.hidden = true;
          return;
        }
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = this.dataset.provincePlaceholder;
        placeholder.disabled = true;
        placeholder.selected = true;
        this.provinceSelect.append(placeholder);
        provinces.forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          if (selectedProvince && (selectedProvince === value || selectedProvince === label)) option.selected = true;
          this.provinceSelect.append(option);
        });
        this.provinceSelect.disabled = false;
        this.provinceSelect.required = true;
        this.provinceField.hidden = false;
      }

      validDestination() {
        const destination = this.destination();
        return Boolean(destination.country && (!this.provinceSelect.required || destination.province));
      }

      clearErrors() {
        this.status.classList.remove('visually-hidden');
        this.fieldErrors.forEach((element) => {
          element.textContent = '';
          element.hidden = true;
          this.form.elements[element.dataset.fieldError].removeAttribute('aria-invalid');
        });
      }

      showErrors(errors) {
        this.clearErrors();
        errors.forEach(({ field, message }) => {
          const element = this.fieldErrors.find((item) => item.dataset.fieldError === field);
          if (!element) return;
          element.textContent += `${element.textContent ? ' ' : ''}${message}`;
          element.hidden = false;
          this.form.elements[field].setAttribute('aria-invalid', 'true');
        });
        this.status.textContent = Array.from(new Set(errors.map(({ message }) => message))).join(' ');
        this.status.classList.toggle('visually-hidden', errors.every(({ field }) => Boolean(field)));
        this.summaryText.textContent = this.dataset.title;
        this.state.hasEstimate = false;
        this.state.autoEstimate = false;
        this.state.resultText = '';
      }

      async shippingError(response) {
        const payload = await response.json().catch(() => null);
        const errors = [];
        const collect = (value, path = '') => {
          if (typeof value === 'string' && value.trim()) {
            const field = /(^|[.\[])zip\b|postal_code/.test(path) ? 'zip'
              : /(^|[.\[])province\b|province_code/.test(path) ? 'province'
              : /(^|[.\[])country\b|country_code/.test(path) ? 'country' : null;
            errors.push({ field, message: value.trim() });
          } else if (Array.isArray(value)) {
            value.forEach((item) => collect(item, path));
          } else if (value && typeof value === 'object') {
            Object.entries(value).forEach(([key, item]) => collect(item, path ? `${path}.${key}` : key));
          }
        };
        if (response.status === 422 || response.status === 400) {
          collect(payload?.errors || payload);
        }
        const error = new Error('shipping');
        error.shippingErrors = errors.length ? errors : [{
          field: null,
          message: response.status === 429 ? this.dataset.busy
            : response.status === 422 || response.status === 400 ? this.dataset.destinationError : this.dataset.error,
        }];
        return error;
      }

      queueAutomaticEstimate() {
        clearTimeout(this.automaticTimer);
        this.automaticTimer = setTimeout(() => {
          if (this.isConnected && this.state.autoEstimate && this.validDestination()) this.estimate(null, true);
        }, 500);
      }

      cartSignature(cart) {
        return JSON.stringify(cart.items.map((item) => [item.key, item.quantity, item.final_line_price]));
      }

      async cart() {
        const response = await fetch(`${this.dataset.root}cart.js`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('cart');
        return response.json();
      }

      async estimate(event, automatic = false) {
        if (event) event.preventDefault();
        this.clearErrors();
        const destination = this.destination();
        const missing = [];
        if (!destination.country) missing.push({ field: 'country', message: this.dataset.requiredCountry });
        if (this.provinceSelect.required && !destination.province) missing.push({ field: 'province', message: this.dataset.requiredProvince });
        if (missing.length) {
          this.showErrors(missing);
          this.form.elements[missing[0].field].focus();
          return;
        }
        const requestId = ++this.requestId;
        this.state.autoEstimate = true;
        this.state.hasEstimate = false;
        this.state.resultText = '';
        this.submitButton.disabled = true;
        this.results.textContent = '';
        this.status.textContent = automatic ? this.dataset.updating : this.dataset.loading;
        this.summaryText.textContent = automatic ? this.dataset.updating : this.dataset.loading;
        if (!automatic) this.details.open = true;
        this.saveDestination();
        const fields = new FormData(this.form);
        const address = new URLSearchParams({
          'shipping_address[zip]': String(fields.get('zip')).trim(),
          'shipping_address[country]': String(fields.get('country')).trim(),
          'shipping_address[province]': String(fields.get('province') || '').trim(),
        });

        try {
          const before = await this.cart();
          if (requestId !== this.requestId || !this.isConnected) return;
          if (!before.item_count || before.requires_shipping === false) {
            this.state.autoEstimate = false;
            this.status.textContent = this.dataset.empty;
            this.summaryText.textContent = this.dataset.title;
            return;
          }
          const signature = this.cartSignature(before);
          const root = this.dataset.root;
          const prepare = await fetch(`${root}cart/prepare_shipping_rates.json?${address}`, {
            method: 'POST',
            credentials: 'same-origin',
          });
          if (!prepare.ok) throw await this.shippingError(prepare);

          let rates;
          for (let attempt = 0; attempt < 12; attempt += 1) {
            await new Promise((resolve) => setTimeout(resolve, 750));
            if (requestId !== this.requestId) return;
            const response = await fetch(`${root}cart/async_shipping_rates.json?${address}`, {
              credentials: 'same-origin',
            });
            if (!response.ok) throw await this.shippingError(response);
            const data = await response.json();
            if (data && Array.isArray(data.shipping_rates)) {
              rates = data.shipping_rates;
              break;
            }
          }
          if (!rates) throw new Error('timeout');
          const after = await this.cart();
          if (requestId !== this.requestId) return;
          if (signature !== this.cartSignature(after)) {
            this.status.textContent = this.dataset.updating;
            this.summaryText.textContent = this.dataset.updating;
            this.queueAutomaticEstimate();
            return;
          }
          if (!rates.length) {
            this.showErrors([{ field: null, message: this.dataset.noRates }]);
            return;
          }
          const pricedRates = rates
            .map((rate) => ({ rate, numericPrice: Number(rate.price) }))
            .filter(({ numericPrice }) => Number.isFinite(numericPrice))
            .sort((a, b) => a.numericPrice - b.numericPrice);
          if (!pricedRates.length) throw new Error('prices');
          const cheapest = pricedRates[0];
          const currency = cheapest.rate.currency || after.currency || window.Shopify?.currency?.active;
          const price = currency
            ? new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cheapest.numericPrice)
            : String(cheapest.rate.price);
          const resultText = this.dataset.result.replace('[price]', price);
          this.results.textContent = resultText;
          this.summaryText.textContent = resultText;
          this.status.textContent = '';
          this.state.hasEstimate = true;
          this.state.resultText = resultText;
          this.saveDestination();
        } catch (error) {
          if (requestId === this.requestId) {
            this.showErrors(error.shippingErrors || [{
              field: null,
              message: error.message === 'timeout' ? this.dataset.timeout : this.dataset.error,
            }]);
          }
        } finally {
          if (requestId === this.requestId) this.submitButton.disabled = false;
        }
      }
    }
    customElements.define('shipping-rate-estimator', ShippingRateEstimator);
  }
  } catch(e) { console.error(e); }
})();

})();
